import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const key = "token";
const key1 = "openid";
const key2 = "mobile";
const store = new Vuex.Store({
  state() {
    return {
      token: "",
      openid: "",
      mobile: ""
    };
  },
  getters: {
    getStorage: function(state) {
      if (!state.token) {
        state.token = JSON.parse(localStorage.getItem(key));
      }
      return state.token;
    },
    getStorage1: function(state) {
      if (!state.openid) {
        state.openid = JSON.parse(localStorage.getItem(key1));
      }
      return state.openid;
    },
    getStorage2: function(state) {
      if (!state.mobile) {
        state.mobile = JSON.parse(localStorage.getItem(key2));
      }
      return state.mobile;
    }
  },
  mutations: {
    $_setStorage(state, value) {
      state.token = value;
      localStorage.setItem(key, JSON.stringify(value));
    },
    $_removeStorage(state) {
      state.token = null;
      localStorage.removeItem(key);
    },
    $_setStorage1(state, value) {
      state.openid = value;
      localStorage.setItem(key1, JSON.stringify(value));
    },
    $_removeStorage1(state) {
      state.openid = null;
      localStorage.removeItem(key1);
    },
    $_setStorage2(state, value) {
      state.mobile = value;
      localStorage.setItem(key2, JSON.stringify(value));
    },
    $_removeStorage2(state) {
      state.mobile = null;
      localStorage.removeItem(key2);
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js